import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import TopAwardSubBoxImage from "../../../assests/images/About-top-rated-awards-images/top-rated-awards-2023.webp";
import SponsorsImageOne from "../../../assests/images/About-top-rated-awards-images/volunteer-match.webp";
import LatestNewsForm from "../../../components/common/latestNewsForm";

import {
    WhatAreTopRatedAwardSection,
    WhatAreTopRatedAwardWrap,
    TopRatedAwardSubTitle,
    TopAwardSubBox,
    AwardSubBoxImage,
    AwardSubBoxContent,
    AwardSubBoxStrongText,
    AwardSubBoxText,
    WhatAreTopRatedAwardText,
    WhatAreTopRatedAwardStrongText,
    TopAwardNonprofitsSec,
    NonprofitsBox,
    NonprofitsBoxTitle,
    NonprofitsBoxText,
    NonprofitsBoxSpan,
    SpecialThanksSec,
    SpecialThanksWrap,
    SpecialThanksText,
    SpecialThanksImageWrap,
    SpecialThanksImageBox,
    TopAwardLatestNewsSec,
  } from "./awardsStyle";
  
import { useNavigate } from "react-router-dom";
import { sponsorsHandler } from "../../../redux/slices/sponsors/sponsors-slice";
import { useDispatch,useSelector } from "react-redux";
import { MESSAGE } from "../../../utils/message";
  
const TopRatedAwardAbout = () => {
    const dispatch: any = useDispatch();
    const sponsorList : any = useSelector((state:any) =>state?.sponsors?.data?.data);
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(sponsorsHandler())
    },[])
    return (
        <>
        <WhatAreTopRatedAwardSection>
            <Container className="cont-w">
                <Row>
                    <Col lg="6" sm="12">
                    <WhatAreTopRatedAwardWrap>
                        <TopRatedAwardSubTitle>What Are the Top-Rated Awards?</TopRatedAwardSubTitle>

                        <TopAwardSubBox>
                            <AwardSubBoxImage>
                                <Image src={TopAwardSubBoxImage} alt="Top Award SubBox Image" />
                            </AwardSubBoxImage>
                            <AwardSubBoxContent>
                                <AwardSubBoxStrongText>The GreatNonprofits seal is the second most trusted rating seal, after the Better Business Bureau*</AwardSubBoxStrongText>
                                <AwardSubBoxText>*According to a study by Software Advice</AwardSubBoxText>
                            </AwardSubBoxContent>
                        </TopAwardSubBox>

                    </WhatAreTopRatedAwardWrap>
                    </Col>

                    <Col lg="6" sm="12">
                        <WhatAreTopRatedAwardText>

                        The <WhatAreTopRatedAwardStrongText onClick={() => navigate('/about/greatnonprofits-badge')}>GreatNonprofits Top-Rated Awards</WhatAreTopRatedAwardStrongText> is the one and only people’s choice award where volunteers, donors, and people served by nonprofits are asked to share stories of inspiration, express their appreciation, and potentially help nonprofits earn a spot on the prestigious GreatNonprofits <WhatAreTopRatedAwardStrongText onClick={() => navigate('/awards/browse')}>Top-Rated Nonprofits List.</WhatAreTopRatedAwardStrongText>
                        
                        </WhatAreTopRatedAwardText>
                    </Col>
                </Row>
            </Container>
        </WhatAreTopRatedAwardSection>

        <TopAwardNonprofitsSec>
            <Container className="cont-w">
                <Row>
                    <Col lg="12">
                    <NonprofitsBox>
                        <NonprofitsBoxTitle>{MESSAGE.nonprofits}</NonprofitsBoxTitle>
                    
                        <NonprofitsBoxText>Did you know that 7 out of 10 people say that the presence of a rating badge increases their likelihood of giving to a nonprofit?</NonprofitsBoxText>

                        <NonprofitsBoxText>Nonprofits can gain more exposure and trust with current and potential donors, volunteers and all supporters by earning a spot on the GreatNonprofits Top-Rated list. You can start today by <NonprofitsBoxSpan onClick={() => navigate('/about/get-started')}>claiming your organization profile</NonprofitsBoxSpan> and then asking your supporters to <NonprofitsBoxSpan onClick={() => navigate('/detail-award')}>share their stories</NonprofitsBoxSpan> of your greatness.</NonprofitsBoxText>

                        <button className="learn-qualify-btn" type="button" onClick={() => navigate("/detail-award")}>{MESSAGE.learnHowToQualify}</button>

                    </NonprofitsBox>

                    <NonprofitsBox>
                        <NonprofitsBoxTitle>{MESSAGE.volunteersDonorsSupporters}</NonprofitsBoxTitle>
                    
                        <NonprofitsBoxText>Help others find great nonprofits! If you are a volunteer, donor, supporter, or client served by a nonprofit, <NonprofitsBoxSpan onClick={() => navigate('/write-review')}>share your stories and let others know</NonprofitsBoxSpan> about the great work they do.</NonprofitsBoxText>

                        <NonprofitsBoxText>
                        Any nonprofit that gathers 10 or more 4- or 5-star ratings and maintains an overall average of 3.5 stars, will win a GreatNonprofits Top-Rated award. This recognition helps nonprofits stand out from the crowd to gain volunteers, donations, and more supporters. Together, we can make an even bigger impact!
                        </NonprofitsBoxText>

                        <button className="btn-outline-success-blue" type="button" onClick={() => navigate('/toprated/nominate')}>{MESSAGE.learnHowToNominate}</button>

                    </NonprofitsBox>

                    </Col>
                </Row>
            </Container>
        </TopAwardNonprofitsSec>

        <SpecialThanksSec>
            <Container className="cont-w">
                <Row>
                    <Col lg="12" md="12">
                        <SpecialThanksWrap>
                            <SpecialThanksText>{MESSAGE.specialThanksSponsors}</SpecialThanksText>
                            <SpecialThanksImageWrap>
                                {sponsorList?.map((_sponsor:any, index:number) => (
                                    <SpecialThanksImageBox key={index+1}>
                                    <Image src={SponsorsImageOne} alt="Sponsors Image" />
                                    </SpecialThanksImageBox>
                                ))}
                            </SpecialThanksImageWrap>
                        </SpecialThanksWrap>

                    </Col>
                </Row>
            </Container>
        </SpecialThanksSec>

        <TopAwardLatestNewsSec>
            <Container className="cont-w">
                <Row>
                    <Col lg="12" md="12">
                        <LatestNewsForm/>
                    </Col>
                </Row>
            </Container>
        </TopAwardLatestNewsSec>
        </>
    )
};
export default TopRatedAwardAbout;